export enum MapLayerId {
  TEMPERATURE = 'temp',
  CLOUD_COVERAGE = 'cloud-cover',
  WIND_SPEED = 'wind-speed',
  PRECIP_RADAR = 'precip-radar',
  PRECIP_FORECAST = 'precip-forecast',
}
